export const UNSUB_NOTICE_COOKIE = '_cookie_consent_unsubscribe_notice'
